import React from "react";
import Success from "../../../assets/assets/nip-approved.svg";
import { PropTypes } from "prop-types";
import Rodal from "rodal";

const SuccessModal = ({ hide, visible }) => {
  return (
    <Rodal
      width={Number("520")}
      height={Number("480")}
      visible={visible}
    >
      <div className="success-modal-body">
        <div className="modal-image">
          <img src={Success} alt="icon" />
        </div>
        <h3>Application sent</h3>
        <p>
          Your test has been submitted for review. Kindly check back when <br />{" "}
        admin approves
      </p>
        <div className="modal-btn">
          <button onClick={() => hide()} data-testid="hideModal">continue</button>
        </div>
      </div>
    </Rodal>

  );
};

SuccessModal.propTypes = {
  hide: PropTypes.func,
  visible: PropTypes.any
}

export default SuccessModal;
